const isDevelopment = process.env.NODE_ENV === 'development'

export const reportCalculationsError = (scope, error, context = {}) => {
  if (!isDevelopment) {
    return
  }

  console.error('[Calculations]', scope, {
    message: error?.message,
    stack: error?.stack,
    ...context
  })
}

export const runCalculationsSafely = (scope, fn, fallback) => {
  try {
    return fn()
  } catch (error) {
    reportCalculationsError(scope, error)
    return fallback
  }
}
